if (typeof Plugin_DotacniTitul === 'undefined') {
    var Plugin_DotacniTitul = {

        init: function () {
            // nová žádost z titulu
            var buttonNewRequest = $('#button-new-request');
            if (buttonNewRequest.length) {
                buttonNewRequest
                    .off('click')
                    .on('click', function (e) {
                    e.preventDefault();
                    var url = window.location.href;
                    url = url.replace('/section/dotacnititul/item/detail', '/section/zadost/item/add');
                    url = url.replace('/section/dotacnititul/item/edit', '/section/zadost/item/add');
                    url = url.replace(/^(.+\/)([0-9]+)\/?$/, '$1?idTitul=$2');
                    window.location.href = url;
                });
            }
        }
    }
}

$(document)
    .ready(function () {
        Plugin_DotacniTitul.init();
    });
